import { render, staticRenderFns } from "./StyleEditorBorder.vue?vue&type=template&id=1a2315eb"
import script from "./StyleEditorBorder.vue?vue&type=script&lang=ts"
export * from "./StyleEditorBorder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2315eb')) {
      api.createRecord('1a2315eb', component.options)
    } else {
      api.reload('1a2315eb', component.options)
    }
    module.hot.accept("./StyleEditorBorder.vue?vue&type=template&id=1a2315eb", function () {
      api.rerender('1a2315eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/StyleEditorBorder.vue"
export default component.exports